import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const TableStyle = makeStyles({
  TableWrapper: {
    "& .MuiBackdrop-root": {
      color: "#fff",
      zIndex: "1201",
    },
    boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
    backgroundColor: colors.white,
    borderRadius: "6px",
  },
  status: {
    backgroundColor: "#f5dcc9",
    padding: "5px",
    textAlign: "center",
    borderRadius: "7px",
    fontSize: "13px",
    color: "#c77935",
    fontWeight: "bold",
  },
  statusPending: {
    backgroundColor: "#fff4d1",
    color: "#9e6600",
    padding: "12px 0",
  },
  statusProcessing: {
    backgroundColor: "#d9f2de",
    color: "#1c7c32",
    padding: "12px 0",
  },
  statusApplied: {
    backgroundColor: "#d3eafd",
    color: "#005f99",
    padding: "12px 0",
  },
  statusDismissed: {
    backgroundColor: "#e0e0e0",
    color: "#5f5f5f",
    padding: "12px 0",
  },
  statusFailed: {
    backgroundColor: "#fac08f",
    color: "#fe1a13",
    padding: "12px 0",
  },
  dismiss: {
    color: "#000",
    fontWeight: 700,
    cursor: "pointer",
    marginLeft: "15px"
  },
  retry: {
    color: "#ff0000",
    fontWeight: 700,
    cursor: "pointer",
  },
  viewLog: {
    "& a": {
      "&:link, &:visited, &:hover, &:active": {
        color: "#444",
        fontWeight: 700,
        cursor: "pointer"
      }
    }
  },
  customTable: {
    marginTop: 25,
    maxHeight: 728,
    boxShadow: "none",
    "@media (max-height: 900px)": {
      maxHeight: 552,
    },
    "@media (max-height: 768px)": {
      maxHeight: 420,
    },
    "& .MuiTable-root": {
      minWidth: 1600,
      "& .MuiTableCell-root": {
        fontWeight: 500,
        color: colors.black,
        border: "none",
        wordBreak: "break-word",
      },
      "& .MuiTableHead-root": {
        boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
        backgroundColor: colors.white,
        "& .MuiTableCell-root": {
          color: "rgba(33, 33, 33, 0.7)",
          padding: "30px 19px",
          backgroundColor: colors.white,
          borderBottom: "1px solid #f4f4f4",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
            width: "240px"
          },
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "22px 19px",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
        },
      },
      "& .check": {
        width: "30px",
      },
      "& .customer": {
        width: "200px",
      },
      "& .impactedPeriod": {
        width: "210px",
      },
      "& .newRate": {
        width: "120px",
        textAlign: "center",
      },
      "& .impactedJobs": {
        width: "190px",
        textAlign: "center",
      },
      "& .impactedDraftInvoices": {
        width: "190px",
        textAlign: "center",
      },
      "& .lastUpdate": {
        width: "170px",
      },
      "& .status": {
        width: "220px",
        textAlign: "center",
      },
      "& .action": {
        minWidth: "220px",
        textAlign: "center",
      },
    },
  },
});

export { TableStyle };
